import getApiClient from './../../../../plugins/api'
import updateNavigationRoutes from '../../../../containers/_nav'

export default {
    login: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.loginError = ''

        let postData = {
            username: self.username,
            password: self.password
        }

        api.post('/login', postData)
            .then(function(response) {
                self.$store.commit('setJwtToken', response.data.token)

                self.$cookie.set('token', response.data.token, {
                    expires: 30,
                    domain: 'voudetrip.com.br'
                });

                api.get('/user/check_session').then(function(response) {
                    let userId = response.data.id


                    api.get(`/user/${userId}`).then(function(user) {
                        self.$store.commit('setUser', user.data)
                        updateNavigationRoutes()

                        const next = self.$route.params.next ?? '/dashboard'

                        self.$router.push(next)
                    })
                })
            })
            .catch(function(error) {
                let responseData = error.response.data,
                    errorCode = error.response.status

                switch (errorCode) {
                    case 401:
                        self.loginError = 'Usuário ou senha inválidos'
                        break;
                    case 500:
                        self.loginError = 'Ocorreu um erro no servidor'
                        break;
                    default:
                        self.loginError = responseData.error
                        break;
                }
            })

    }
}
